import PropTypes from 'prop-types'
import { putUser, putUserMod } from '../../../utils/APIs/users'
import { ColorPicker } from '../../../utils/colors'

const ChangeColorForm = ({ user, callbackFunction, modView = false }) => {
  const handleSetColor = async (value) => {
    const response = modView
      ? await putUserMod(user, 'userService.profile.color', value)
      : await putUser(user, 'userService.profile.color', value)

    if (response && response.status === 200) {
      if (callbackFunction) {
        callbackFunction(response.data)
      }
    }
  }

  return (
    <div className="mb-auto flex w-fill">
      <div className="flex flex-col gap-2 justify-start items-start">
        <ColorPicker handleSelect={handleSetColor} />
      </div>
    </div>
  )
}

ChangeColorForm.propTypes = {
  user: PropTypes.string.isRequired
}

export default ChangeColorForm
